import { MaintenanceForwardingSectionsProps } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type";
import MaintenanceWorkflowForwardingDirectiveEntry from "../../sections/DirectiveEntry";

const MaintenanceWorkflowForwardingOnGoingEstablishmentChoice = ({
  forwarding,
}: MaintenanceForwardingSectionsProps) => {
  return (
    <div className="flex-1 overflow-auto flex flex-col gap-4">
      <MaintenanceWorkflowForwardingDirectiveEntry
        forwarding={forwarding}
      />
    </div>
  );
}

export default MaintenanceWorkflowForwardingOnGoingEstablishmentChoice;
